import EmailUs from 'components/EmailUs/EmailUs';

export default EmailUs;
